import { render, staticRenderFns } from "./FloatingWidget.vue?vue&type=template&id=52758ef0&scoped=true&"
import script from "./FloatingWidget.vue?vue&type=script&lang=js&"
export * from "./FloatingWidget.vue?vue&type=script&lang=js&"
import style0 from "./FloatingWidget.vue?vue&type=style&index=0&id=52758ef0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52758ef0",
  null
  
)

export default component.exports